import React, { useCallback } from 'react';
const CompetitorCell = (props) => {
    var _a, _b, _c, _d;
    const getTextWidth = useCallback((text) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context)
            return 0;
        context.font = getComputedStyle(document.getElementsByClassName('ag-cell-value')[0]).font;
        return context === null || context === void 0 ? void 0 : context.measureText(text).width;
    }, []);
    if (!props.colDef)
        return;
    const isCollapsed = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.isCollapsed) !== null && _b !== void 0 ? _b : false;
    const columnName = props.colDef.field;
    let competitorsList = (_d = (_c = props.data) === null || _c === void 0 ? void 0 : _c.documents.map((metadata) => {
        var _a;
        const competitors = (_a = metadata.find(m => m.name === columnName)) === null || _a === void 0 ? void 0 : _a.value;
        return Array.isArray(competitors) ? competitors : [];
    })) !== null && _d !== void 0 ? _d : [];
    competitorsList = competitorsList.filter(val => val && val.length);
    let competitorFlatList = competitorsList.flat();
    competitorFlatList = [...new Set(competitorFlatList)];
    const competitorCount = competitorFlatList.length;
    if (isCollapsed && (props === null || props === void 0 ? void 0 : props.column)) {
        const columnWidth = props.column.getActualWidth();
        const flatString = competitorFlatList.join(', ');
        const currentTextWidth = getTextWidth(flatString) + 34;
        let newValue = flatString;
        if (currentTextWidth > columnWidth) {
            newValue = flatString.substring(0, (columnWidth / (currentTextWidth / flatString.length)) - 4) + `...${competitorCount}`;
        }
        return React.createElement("span", { title: flatString }, newValue);
    }
    return competitorsList.map(competitorList => {
        const value = competitorList.join(', ');
        return (React.createElement("span", { title: value },
            value,
            React.createElement("br", null)));
    });
};
export default CompetitorCell;
